import { getCurrentStep } from '../store/flow/selectors';
export const hasStepJustBeenCompleted = (state, steps) => {
  const currentStep = getCurrentStep(state);
  return Boolean(steps && currentStep && steps.includes(currentStep));
};